// extracted by mini-css-extract-plugin
export default {"cards":"cards___yML8W","cardLayout":"cardLayout___Ifke2","cardTitle":"cardTitle___TlaGZ","cardContent":"cardContent___U8zij"};